import TeLogin from './index.vue';


TeLogin.install = function(Vue) {
  Vue.component(TeLogin.name, TeLogin);
};

export default TeLogin;